export type PositionInfo = {
  tokenId: bigint;
  owner?: `0x${string}`;
  poolKey: {
    currency0: `0x${string}`;
    currency1: `0x${string}`;
    fee: number;
    tickSpacing: number;
    hooks: `0x${string}`;
  };
  tickLower: number;
  tickUpper: number;
  liquidity: bigint;
  feeGrowthInside0X128: bigint;
  feeGrowthInside1X128: bigint;
  feeGrowthInside0LastX128: bigint;
  feeGrowthInside1LastX128: bigint;
  currency0UncollectedFees: bigint;
  currency1UncollectedFees: bigint;
};

export type TickInfo = {
  liquidityGross: bigint;
  liquidityNet: bigint;
  feeGrowthOutside0X128: bigint;
  feeGrowthOutside1X128: bigint;
};

export type Pool = readonly [
  {
    sqrtPriceX96: bigint;
    tick: number;
    protocolFee: number;
    swapFee: number;
  },
  bigint,
  bigint,
  bigint,
];

// tick boundaries
export enum Bound {
  LOWER = 'LOWER',
  UPPER = 'UPPER',
}

export type ChainAgnosticAddress = `0x${string}`;

export type DurationType = '1d' | '1w' | '1m' | '1y';
